<template>
  <div class="bg-gp-midnight-2 z-14 fixed inset-x-4 bottom-16 min-w-[200px] p-5 drop-shadow-2xl sm:left-auto">
    <slot></slot>
  </div>
</template>
